const CLINIC_OFFSET_MINUTES = 8 * 60;
const CLINIC_OFFSET_MS = CLINIC_OFFSET_MINUTES * 60_000;
const CLINIC_OFFSET_SUFFIX = "+08:00";
export const CLINIC_TIME_ZONE = "Asia/Manila";

function pad2(n) {
  return String(n).padStart(2, "0");
}

function asDate(value) {
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function clinicDateStringFromInstant(value) {
  const d = asDate(value);
  if (!d) return "";
  const shifted = new Date(d.getTime() + CLINIC_OFFSET_MS);
  return [
    shifted.getUTCFullYear(),
    pad2(shifted.getUTCMonth() + 1),
    pad2(shifted.getUTCDate()),
  ].join("-");
}

export function clinicTimePartsFromInstant(value) {
  const d = asDate(value);
  if (!d) return null;
  const shifted = new Date(d.getTime() + CLINIC_OFFSET_MS);
  return {
    hour: shifted.getUTCHours(),
    minute: shifted.getUTCMinutes(),
  };
}

export function clinicIsoMinuteFromInstant(value) {
  const date = clinicDateStringFromInstant(value);
  const parts = clinicTimePartsFromInstant(value);
  if (!date || !parts) return "";
  return `${date}T${pad2(parts.hour)}:${pad2(parts.minute)}`;
}

export function clinicInstantFromIsoMinute(value) {
  if (!value || typeof value !== "string") return new Date(NaN);
  const [date = "", time = ""] = value.split("T");
  const [hour = "0", minute = "0"] = time.slice(0, 5).split(":");
  return clinicDateAt(date, Number(hour), Number(minute), 0);
}

export function clinicTodayDateString(now = new Date()) {
  return clinicDateStringFromInstant(now);
}

export function clinicDateAt(date, hour = 0, minute = 0, second = 0) {
  if (!date) return new Date(NaN);
  return new Date(`${date}T${pad2(hour)}:${pad2(minute)}:${pad2(second)}${CLINIC_OFFSET_SUFFIX}`);
}

export function clinicDateAtMinutes(date, absoluteMinutes, second = 0) {
  const total = Number(absoluteMinutes);
  if (!Number.isFinite(total)) return new Date(NaN);
  const hour = Math.floor(total / 60);
  const minute = total % 60;
  return clinicDateAt(date, hour, minute, second);
}

export function clinicAddMinutes(value, minutes) {
  const d = asDate(value);
  if (!d) return new Date(NaN);
  return new Date(d.getTime() + Number(minutes || 0) * 60_000);
}

export function clinicDayRange(date) {
  const from = clinicDateAt(date, 0, 0, 0);
  const to = clinicDateAt(addClinicDays(date, 1), 0, 0, 0);
  return { from, to };
}

export function addClinicDays(date, days) {
  if (!date) return "";
  const base = clinicDateAt(date, 12, 0, 0);
  if (Number.isNaN(base.getTime())) return "";
  base.setUTCDate(base.getUTCDate() + Number(days || 0));
  return clinicDateStringFromInstant(base);
}

export function clinicDayIndex(date) {
  const d = clinicDateAt(date, 12, 0, 0);
  return Number.isNaN(d.getTime()) ? null : d.getUTCDay();
}
